import React from 'react'
import MyImage from '../MyImage/MyImage'
import { getAltText } from '../../../utils/safe'

const Color = ({
  img,
  colorName,
  onClick,
  size,
  sizeMobile,
  isActive,
  selectable,
  onMouseEnter,
  onMouseLeave,
  fromPdf = false,
  variant = '',
}) => {
  return (
    <div
      className={
        'color' +
        (size ? ' color--' + size : '') +
        (variant ? ' color--' + variant : '') +
        (sizeMobile ? ' color--mobile-' + sizeMobile : '') +
        (selectable ? ' color--selectable' : '') +
        (isActive ? ' color--active' : '')
      }
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="color__image-box">
        {fromPdf ? (
          <img className="color__image" src={img?.url || img} alt={getAltText(img) || colorName} title={colorName} />
        ) : (
          <MyImage
            className="color__image"
            src={img?.url}
            alt={getAltText(img) || colorName}
            title={colorName}
            width={variant !== 'image' ? 28 : 60}
            height={variant !== 'image' ? 28 : 60}
          />
        )}
        {/* size Color - 4px tra padding e bordo */}
      </div>
    </div>
  )
}

export default React.memo(Color)
